/**
 * Shared MUI `sx` helpers for the access contact page section chrome (paper, header bar, title).
 */
import { alpha, Theme } from "@mui/material/styles";

/** Outer shell for a major block on the contact page (border like table container). */
export function ContactInfoSectionPaperSx(theme: Theme) {
	return {
		overflow: "hidden",
		border: `1px solid ${alpha(theme.palette.divider, theme.palette.mode === "dark" ? 0.14 : 0.08)}`,
		boxShadow: theme.shadows[1],
		backgroundColor: theme.palette.background.paper,
	} as const;
}

/**
 * Blue bar matching BaseTable {@link TableHeaderSection} rhythm (padding, title weight)
 * with primary background instead of surface.
 */
export function ContactInfoSectionHeaderSx(theme: Theme) {
	return {
		px: 3,
		py: 1.5,
		backgroundColor: theme.palette.primary.main,
		borderBottom: `1px solid ${alpha(theme.palette.primary.dark, 0.35)}`,
	} as const;
}

/** Title text inside the blue section header (contrast on primary). */
export function ContactInfoSectionTitleSx(theme: Theme) {
	return {
		fontWeight: 600,
		fontSize: "1rem",
		letterSpacing: "0.02em",
		lineHeight: 1.4,
		color: theme.palette.primary.contrastText,
	} as const;
}
